import type { RecentBooksActivityEntity } from "../entities/BooksHealthEntity";
import type { BooksHealthRepository } from "../repositories/BooksHealthRepository";

export class GetBooksHealthRecentActivityUseCase {
  constructor(private readonly repository: BooksHealthRepository) {}

  async execute(): Promise<RecentBooksActivityEntity[]> {
    return this.repository.getBooksHealthRecentActivity();
  }
}
